import Actions from '../../odata/actions';

const actions = new Actions('supplier', 'suppliers');

export default actions;
